import React, { useEffect } from 'react';
import clsx from 'clsx';
import CustomDatePicker from '@/components/datepicker';
import { DATE_PICKER_FORMAT, DATE_PICKER_PORTAL_ID, TIME_PICKER_CAPTION, TIME_PICKER_FORMAT, TIME_PICKER_INTERVAL_MINUTES } from '../../boutique-classroom.constants';

interface DateTimeInputProps {
	type: 'date' | 'time';
	value: Date | null;
	onChange: (value: Date | null) => void;
	minDate?: Date;
	minTime?: Date;
	maxTime?: Date;
	className?: string;
}

const ICON_BY_TYPE: Record<DateTimeInputProps['type'], string> = {
	date: 'icons-calendar',
	time: 'icons-clock-circle'
};

const PLACEHOLDER = ' ';
const PORTAL_CLASS_NAME = 'custom-datepicker';

function ensurePortalElement(): void {
	if (document.getElementById(DATE_PICKER_PORTAL_ID)) return;
	const element = document.createElement('div');
	element.id = DATE_PICKER_PORTAL_ID;
	element.className = PORTAL_CLASS_NAME;
	document.body.appendChild(element);
}

export const DateTimeInput: React.FC<DateTimeInputProps> = ({ type, value, onChange, minDate, minTime, maxTime, className }) => {
	const isTime = type === 'time';

	useEffect(() => {
		ensurePortalElement();
	}, []);

	return (
		<div className={clsx('cem-datetime', `cem-datetime--${type}`, { 'cem-datetime--empty': !value }, className)}>
			<CustomDatePicker
				className="cem-datetime__picker"
				selectedDate={value}
				onChange={onChange}
				onResetValue={() => onChange(null)}
				placeholderLabel={PLACEHOLDER}
				dateFormat={isTime ? TIME_PICKER_FORMAT : DATE_PICKER_FORMAT}
				minDate={minDate}
				showTimeSelect={isTime}
				showTimeSelectOnly={isTime}
				timeIntervals={isTime ? TIME_PICKER_INTERVAL_MINUTES : undefined}
				timeCaption={isTime ? TIME_PICKER_CAPTION : undefined}
				minTime={minTime}
				maxTime={maxTime}
				portalId={DATE_PICKER_PORTAL_ID}
				popperPlacement="bottom-start"
				shouldCloseOnSelect
			/>
			<span
				className="cem-datetime__icon"
				aria-hidden="true">
				<i className={ICON_BY_TYPE[type]} />
			</span>
		</div>
	);
};

export default DateTimeInput;
